import styled from '@emotion/styled';

import COLOR from '../../../../shared/constant/colorset';
import { Question24x24cccc } from '../../../../shared/images';
import { zIndex } from '../../../../shared/styles';

const RecommendWrap = styled.a`
  &:hover {
    div {
      display: block;
    }
  }
`;

const Img = styled.img();

const RecommendDetail = styled.div`
  display: none;
  position: absolute;
  top: 36px;
  left: -6px;
  z-index: ${zIndex.headerMenu};
  max-width: 272px;
  padding: 14px;
  border: 1px solid ${COLOR.kurlyGray800};
  border-radius: 3px;
  background: ${COLOR.kurlyWhite};
  color: ${COLOR.kurlyGray600};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
`;

const RECOMMEND_MESSAGE_SEARCH = '검색어 적합성과 소비자 인기도(판매량, 판매금액, 조회수 등)를 종합적으로 고려한 순서입니다.';
const RECOMMEND_MESSAGE = '소비자 인기도(판매량, 판매금액, 조회수 등), 상품 출시일, 수요 적합성, 상품 운영상 필요 등을 종합적으로 고려한 순서입니다.';

interface Props {
  section: string;
}

export default function RecommendView({
  section,
}: Props) {
  return (
    <RecommendWrap>
      <Img src={Question24x24cccc} alt='' />
      <RecommendDetail>
        {section === 'search'
          ? RECOMMEND_MESSAGE_SEARCH
          : RECOMMEND_MESSAGE
        }
      </RecommendDetail>
    </RecommendWrap>
  );
}
